import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import App from './App';

import Sidebar from '../components/Sidebar/Sidebar';
import { ContentWrapper } from './Common/styled/ContentWrapper';
import Header from './Header/Header';
import { MainContainer } from './Common/styled/MainContainer';
import { LicenseWarning } from './Common/LicenseWarning';

export const Layout = ({ children, type }) => {
  const dispatch = useDispatch();

  const { fixSidebar, licenseWarning, visibleSidebar } = useSelector((state) => state.userInterface);

  const handleDrawerToggle = () => {
    dispatch({ type: 'SET_VISIBILITY_FILTER', filter: { visibleSidebar: false, visibleWorkspaces: false } });
  };

  const handleSwitch = () => {
    dispatch({ type: 'SET_VISIBILITY_FILTER', filter: { visibleSidebar: false, visibleWorkspaces: false, fixSidebar: !fixSidebar } });
  };

  return (
    <App>
      <Sidebar
        type={type}
        visibleSidebar={visibleSidebar}
        fixSidebar={fixSidebar}
        handleDrawerToggle={handleDrawerToggle}
        handleSwitch={handleSwitch}
      />
      <ContentWrapper fixSidebar={fixSidebar}>
        <Header type={type} fixSidebar={fixSidebar} />
        <MainContainer>
          {licenseWarning && <LicenseWarning />}
          {children}
        </MainContainer>
      </ContentWrapper>
    </App>
  );
};

export default Layout;
